import { clearOfflineData } from './offlineStore';
import { isNativeApp } from './native';
import { environmentForEmail, apiForEnvironment, PRODUCTION_API_URL, STAGING_API_URL } from './environmentRouting';
export { PRODUCTION_API_URL, STAGING_API_URL };

// Retire the old manual selector without sending its staging token to production.
if (isNativeApp() && localStorage.getItem('sep-environment') === 'review' && !localStorage.getItem('sep-session-environment')) {
  localStorage.removeItem('token');
}

// Native sessions select one fixed backend. Browser deployments stay same-origin.
export const API_URL = isNativeApp()
  ? apiForEnvironment(localStorage.getItem('token') ? localStorage.getItem('sep-session-environment') : 'production')
  : (import.meta.env.VITE_API_URL || '');
export function loginTarget(email) {
  const environment = environmentForEmail(email);
  return { environment, apiUrl: isNativeApp() ? apiForEnvironment(environment) : API_URL };
}
export function saveAuthSession(token, environment = 'production') {
  void clearOfflineData().catch(() => {});
  localStorage.removeItem('impersonate_user_id');
  localStorage.removeItem('sep-environment');
  sessionStorage.clear();
  localStorage.setItem('sep-session-environment', environment);
  localStorage.setItem('token', token);
}
export function clearAuthSession() {
  void clearOfflineData().catch(() => {});
  for (const key of ['token', 'sep-session-environment', 'sep-environment', 'impersonate_user_id']) localStorage.removeItem(key);
  sessionStorage.clear();
}
